import React, { useState } from "react";
import {
  CheckOutlined,
  DoubleRightOutlined,
  EyeOutlined,
  PhoneOutlined,
  UserOutlined,
} from "@ant-design/icons";
import "./home.css";
import {
  Avatar,
  Col,
  Flex,
  Row,
  Card,
  Button,
  Rate,
  Tag,
  Carousel,
  Image,
  Space,
  Typography,
} from "antd";
import spatialImg from "../assets/images/spe-1.jpg";
import spatialTowImg from "../assets/images/spe-2.jpg";
import spatialThreeImg from "../assets/images/spe-3.jpg";
import dealBannerImg from "../assets/images/dealBanner.png";
import ReviewSlider from "../components/ReviewSlider";
import { tours } from "../data/toursData";
import FAQAccordion from "../components/FAQAccordion";
import ExploreAttractions from "../components/ExploreAttractions";
import ExplorePlaces from "../components/ExplorePlaces";
import AllSubSubCategoryBoxes from "../components/AllSubSubCategoryBoxes";
import CategorySection from "../components/CategorySection";
import { useNavigate } from "react-router-dom";
const { Text, Paragraph, Title } = Typography;

const offers = [
  {
    img: spatialImg,
    title: "Up to 35% OFF (upto Rs.6,000)",
    desc: "On Domestic Hotels",
    note: "*Offers is Valid Only On Confirmed Hotel Bookings",
  },
  {
    img: spatialTowImg,
    title: "Up to 35% OFF (upto Rs.6,000)",
    desc: "On Domestic Hotels",
    note: "*Offers is Valid Only On Confirmed Hotel Bookings",
  },
  {
    img: spatialThreeImg,
    title: "Up to 35% OFF (upto Rs.6,000)",
    desc: "On Domestic Hotels",
    note: "*Offers is Valid Only On Confirmed Hotel Bookings",
  },
];

// const tours = [
//   {
//     id: 1,
//     image: exploreCountryImg,
//     price: "INR 1,43,200",
//     oldPrice: "INR 2,65,185",
//     savings: "SAVE INR 1,21,985",
//     type: "Standard",
//     tagColor: "blue",
//     badgeColor: "#10239E",
//   },
//   {
//     id: 2,
//     image: exploreCountryTwoImg,
//     price: "INR 1,43,200",
//     oldPrice: "INR 2,65,185",
//     savings: "SAVE INR 1,21,985",
//     type: "Premium",
//     tagColor: "gold",
//     badgeColor: "#D72638",
//   },
//   {
//     id: 3,
//     image: exploreCountryThreeImg,
//     price: "INR 1,43,200",
//     oldPrice: "INR 2,65,185",
//     savings: "SAVE INR 1,21,985",
//     type: "Value",
//     tagColor: "green",
//     badgeColor: "#D72638",
//   },
//   {
//     id: 4,
//     image: exploreCountryThreeImg,
//     price: "INR 1,43,200",
//     oldPrice: "INR 2,65,185",
//     savings: "SAVE INR 1,21,985",
//     type: "Value",
//     tagColor: "green",
//     badgeColor: "#D72638",
//   },
// ];

const CrazyDealsPage = () => {
  const [selectedTour, setSelectedTour] = useState(tours[0]);
  // Store selected by ID instead of index
  const [selectedTourId, setSelectedTourId] = useState(tours[0].id);

  // Find active tour
  const activeTour = tours.find((t) => t.id === selectedTourId);
 const navigate = useNavigate();
  return (
    <>
      <section className="">
        <Carousel autoplay dots>
          <div>
            <div
              className=" h-[500px] bg-cover bg-center flex items-center justify-start px-8 text-white"
              style={{
                background: `conic-gradient(
        from -90deg,
        #E91714 0deg 10deg,
        #F33922 10deg 20deg,
        #E91714 20deg 30deg,
        #F33922 30deg 40deg,
        #E91714 40deg 50deg,
        #F33922 50deg 60deg,
        #E91714 60deg 70deg,
        #F33922 70deg 80deg,
        #E91714 80deg 90deg,
        #F33922 90deg 100deg,
        #E91714 100deg 110deg,
        #F33922 110deg 120deg,
        #E91714 120deg 130deg,
        #F33922 130deg 140deg,
        #E91714 140deg 150deg,
        #F33922 150deg 160deg,
        #E91714 160deg 170deg,
        #F33922 170deg 180deg,
        #E91714 180deg 190deg,
        #F33922 190deg 200deg,
        #E91714 200deg 210deg,
        #F33922 210deg 220deg,
        #E91714 220deg 230deg,
        #F33922 230deg 240deg,
        #E91714 240deg 250deg,
        #F33922 250deg 260deg,
        #E91714 260deg 270deg,
        #F33922 270deg 280deg,
        #E91714 280deg 290deg,
        #F33922 290deg 300deg,
        #E91714 300deg 310deg,
        #F33922 310deg 320deg,
        #E91714 320deg 330deg,
        #F33922 330deg 340deg,
        #E91714 340deg 350deg,
        #F33922 350deg 360deg
      )`,
              }}
            >
              <div className="container">
                <Flex align="center" justify="space-between">
                  <div>
                    <div className="bg-white text-danger px-2 py-1 text-xl font-bold inline-block mb-3">
                      SPRING & SUMMER DEAL
                    </div>
                    <h2
                      className="text-5xl font-bold leading-tight"
                      style={{ textShadow: "0px 2px 4px rgba(0, 0, 0, 0.25)" }}
                    >
                      LIMITED-TIME DISCOUNTS
                      <br />
                      BOOK BEFORE IT’S GONE!
                    </h2>
                    <p
                      className="mt-2 text-2xl"
                      style={{ textShadow: "0px 2px 4px rgba(0, 0, 0, 0.25)" }}
                    >
                      Crazy Limited-Period Offers
                      <br />
                      No Hidden Charges. Pure Fun.
                    </p>
                  </div>
                  <Image src={dealBannerImg} preview={false} />
                </Flex>
              </div>
            </div>
          </div>
        </Carousel>
      </section>

      <section className="py-6 px-4 lg:px-0">
        <CategorySection />
      </section>

      <section className="py-6 px-4 lg:px-0">
        <FAQAccordion />
      </section>
      {/* Family </span>  Fun */}
      <section className="py-6 px-4 lg:px-0">
        <ExploreAttractions />
      </section>

      <section className="py-6">
        <ReviewSlider />
      </section>

      <section className="py-6">
        <ExplorePlaces />
      </section>

      <section className="py-6 px-4 lg:px-0">
        <div className="container">
          {/* Header */}
          <div className="flex justify-center align-middle items-center mb-6 flex-col">
            <h2 className="font-medium text-danger text-center">
              <span className="text-primary">Offers For</span> You
            </h2>
            <Paragraph className="!mb-0 font-medium">
              Culture, nature, thrills, and record-breaking experiences
            </Paragraph>
          </div>

          {/* Cards */}
          <Row gutter={[16, 16]}>
            {offers.map((offer, index) => (
              <Col xs={24} sm={12} md={8} key={index}>
                <Card
                  className="flex rounded-[20px] overflow-hidden border-[#E5E5E5] cursor-pointer"
                  styles={{
                    body: {
                      padding: "0px",
                      flex: "1",
                    },
                  }}
                 
                >
                  <div className="flex">
                    {/* Left image with half-oval */}
                    <div className="relative w-[45%] overflow-hidden rounded-r-full">
                      <div className="absolute overflow-hidden rounded-r-full bg-black/10 w-[95%] h-[100%] "></div>
                      <img
                        src={offer.img}
                        alt={offer.title}
                        className="w-full h-full object-cover"
                      />
                    </div>

                    {/* Right content */}
                    <div className="w-[55%] p-5 pl-4 pr-2 flex flex-col justify-center">
                      <h3 className="text-base mb-2 font-medium">
                        {offer.title}
                      </h3>
                      <p className="text-[9px] mb-4 font-normal">
                        {offer.desc}
                      </p>
                      <small className="text-[9px] mb-1 font-medium">
                        {offer.note}
                      </small>
                      <Button
                        type="danger"
                        size="middle"
                        className="px-6 mt-2 text-[11px] rounded-tl-[12px] rounded-bl-none rounded-tr-none rounded-br-[12px] bg-danger hover:bg-red-700 border-none rounded-md px-4 py-1 text-white w-fit"
                      >
                        View Details
                      </Button>
                    </div>
                  </div>
                </Card>
              </Col>
            ))}
          </Row>
        </div>
      </section>
    </>
  );
};

export default CrazyDealsPage;
